import { render, staticRenderFns } from "./DataDivider.vue?vue&type=template&id=3c7ac7a7"
import script from "./DataDivider.vue?vue&type=script&lang=js"
export * from "./DataDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports